
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import MainSection from "./components/MainSection";
import GameList from "./components/GameList";
import Profile from "./components/user/Profile";
import Edit from "./components/user/EditProfile";
import Leaderboard from "./components/activity/Leaderboard";
import Details from "./components/activity/Details";
import AllGames from "./components/activity/AllGames";
import Faq from "./components/footer/Faq";
import Howplay from "./components/footer/HowPlay";
import Login from "./components/user/Login";
import PathNotifier from "./components/PathNotifier";
import Layout from "./components/Layout";
import Privacy from "./components/footer/Privacy";
import TnC from "./components/footer/Tnc";
import AllFeaturedGames from "./components/activity/AllFeaturedGame";
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Layout>
        <MainSection></MainSection>
      </Layout>
    ),
  },
  {
    path: "/profile",
    element: (
      <Layout>
        <Profile></Profile>
      </Layout>
    ),
  },
  {
    path: "/Edit",
    element: (
      <Layout>
        <Edit></Edit>
      </Layout>
    ),
  },
  {
    path: "/viewAll",
    element: (
      <Layout>
        <AllGames></AllGames>
      </Layout>
    ),
  },
  {
    path: "/viewAllFeatured",
    element: (
      <Layout>
        <AllFeaturedGames></AllFeaturedGames>
      </Layout>
    ),
  },
  {
    path: "/leaderboard",
    element: (
      <Layout>
        <Leaderboard></Leaderboard>
      </Layout>
    ),
  },

  {
    path: "/Details/:Cid",
    element: (
      <Layout>
        <Details></Details>
      </Layout>
    ),
  },
  {
    path: "/faq",
    element: (
      <Layout>
        <Faq></Faq>
      </Layout>

    ),
  },
  {
    path: "/howplay",
    element: (
      <Layout>
        <Howplay></Howplay>
      </Layout>
    ),
  },
  {
    path: "/Login",
    element: (
      <Layout>
        <Login></Login>
      </Layout>
    ),
  },
  {
    path: "/Privacy",
    element: (
      <Layout>
        <Privacy></Privacy>
      </Layout>
    ),
  },
  {
    path: "/tnc",
    element: (
      <Layout>
        <TnC></TnC>
      </Layout>
    ),
  },
]);
function App() {
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
}

export default App;
